import ProjectCard from "../project_card/Project_card";
import projects from "./ProjectsList";
const Projects = () => {
  return (
    <>
      <div className="px-5 max-w-[1560px] mx-auto mt-20 py-10 ">
        {/* top */}

        <div className=" flex justify-between items-center gap-5">
          {/* left */}
          <div data-aos="fade-left" className=" text-white w-2/3 font-medium text-[32px] flex items-center gap-2">
            <div className="">
              <span className="text-[#C778DD]">#</span>projects
            </div>
            <div className="line w-2/3 h-px bg-[#C778DD]"></div>
          </div>
          {/* right */}
          <div className=" text-white font-medium">
            <a href="/">
              <span>View all ~~&gt;</span>
            </a>
          </div>
        </div>
        {/* bottom */}
        <div className="flex flex-wrap justify-between gap-4 my-12">
          {/* cards */}
          {projects.map((project, index) => {
            return (
              <ProjectCard
                key={index}
                data={project}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Projects;
